var exports = {
  "iE": "xaee3c4fa--338f1b--wrapper",
  "cy": "xaee3c4fa--338f1b--author",
  "mJ": "xaee3c4fa--338f1b--best-advice",
};

module.exports = exports;
